import { CLEAR, CLOSE, DELETE } from 'constants/general';
import { LogoModalStatusType } from 'types/CompanyBranding';

export const getCompanyLogoModalStatus = (logoPath: string | null, logoUrl: string): LogoModalStatusType => {
  if (logoPath) return DELETE;
  if (logoUrl) return CLEAR;
  return CLOSE;
};

export default undefined;